(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/use-get-cms-data-folder.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/use-get-cms-data-folder.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.termsIntegrity.logger;
const TirService = svs.termsIntegrity.sharedComponents.TirService;
const useGetCmsDataFolder = dataGid => {
  const _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    data = _React$useState2[0],
    setData = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    dataError = _React$useState6[0],
    setDataError = _React$useState6[1];
  React.useEffect(() => {
    let isMounted = true;
    const getData = async () => {
      try {
        setLoading(true);
        const _await$TirService$get = await TirService.getCmsDataFolderAsync(dataGid),
          error = _await$TirService$get.error,
          totalCount = _await$TirService$get.totalCount,
          result = _await$TirService$get.result;
        if (isMounted) {
          logger.debug("useGetCmsDataFolder: error: ".concat(error, ", totalCount: ").concat(totalCount, ", result: ").concat(result));
          logger.debug(result);
          setLoading(false);
          if (error) {
            setDataError(true);
          } else if (result && result.length > 0) {
            setData(result);
          }
        }
      } catch (error) {
        if (isMounted) {
          setLoading(false);
          setDataError(true);
          logger.debug("useGetCmsDataFolder error:".concat(error));
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
    };
  }, [dataGid]);
  return {
    data,
    loading,
    dataError
  };
};
svs.termsIntegrity.sharedComponents.useGetCmsDataFolder = useGetCmsDataFolder;

 })(window);